var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaggingNotag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.11111 0 0 3.11111 0 7C0 10.8889 3.11111 14 7 14C10.8889 14 14 10.8889 14 7C14 3.11111 10.8889 0 7 0ZM7 12.4444C3.96667 12.4444 1.55556 10.0333 1.55556 7C1.55556 3.96667 3.96667 1.55556 7 1.55556C10.0333 1.55556 12.4444 3.96667 12.4444 7C12.4444 10.0333 10.0333 12.4444 7 12.4444ZM3.88889 6.22222V7.77778H10.1111V6.22222H3.88889Z",
    fill: "#F35500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaggingNotag);
export default __webpack_public_path__ + "static/media/tagging_notag.7b0a11dbb12333f2df6963cfab3ef424.svg";
export { ForwardRef as ReactComponent };